import React from 'react';
import './ImageSelector.css';

/**
 * Komponente zur Auswahl eines Bildes für das Puzzle
 * 
 * @param {Object} props - Die Komponenten-Properties
 * @param {string} props.selectedImage - Das aktuell ausgewählte Bild
 * @param {Function} props.onImageSelect - Callback bei Bildauswahl
 */
const ImageSelector = ({ selectedImage, onImageSelect }) => {
  // Vordefinierte Bilder zur Auswahl
  const predefinedImages = [
    { id: 1, src: '/images/puzzle1.jpg', name: 'Kutsche' },
    { id: 2, src: '/images/puzzle2.jpg', name: 'Hof' },
    { id: 3, src: '/images/puzzle3.jpg', name: 'Pferd' },
  ];
  
  // Funktion zum Hochladen eines eigenen Bildes
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      onImageSelect(imageUrl);
    }
  };

  return (
    <div className="image-selector">
      <h3>Wähle ein Bild für dein Puzzle:</h3>
      
      <div className="predefined-images">
        {predefinedImages.map((image) => (
          <div 
            key={image.id}
            className={`image-option ${selectedImage === image.src ? 'selected' : ''}`}
            onClick={() => onImageSelect(image.src)}
          >
            <img src={image.src} alt={image.name} />
            <p>{image.name}</p>
          </div>
        ))}
      </div>
      
      <div className="upload-section">
        <p>Oder lade dein eigenes Bild hoch:</p>
        <input 
          type="file" 
          accept="image/*" 
          onChange={handleImageUpload} 
          id="image-upload"
        />
        <label htmlFor="image-upload" className="upload-button">
          Bild auswählen
        </label>
      </div>
      
      {selectedImage && (
        <div className="image-preview">
          <h4>Vorschau:</h4>
          <img src={selectedImage} alt="Ausgewähltes Bild" />
        </div>
      )}
    </div>
  );
};

export default ImageSelector; 